import * as React from 'react';
import {type ChangeEvent, forwardRef} from 'react';
import styles from './Radio.module.scss';

export interface RadioProps {
  label?: string;
  id?: string;
  name?: string;
  value?: string | number;
  checked?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  className?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      label,
      id: providedId,
      name,
      value,
      checked,
      children,
      disabled,
      className,
      onChange,
      ...rest
    },
    ref,
  ) => {
    const generatedId = React.useId();
    const id = providedId || generatedId;

    const containerClasses = [
      styles.radioContainer,
      disabled && styles.disabled,
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <label
        className={containerClasses}
        htmlFor={id}
      >
        <div className={styles.control}>
          <input
            {...rest}
            type="radio"
            id={id}
            name={name}
            value={value}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            ref={ref}
            className={styles.input}
          />
          <div className={styles.icon}>
            <svg
              className={styles.svg}
              viewBox="0 0 24 24"
            >
              <circle
                className={styles.outerCircle}
                cx="12"
                cy="12"
                r="10"
              />
              <circle
                className={styles.innerCircle}
                cx="12"
                cy="12"
                r="5"
              />
            </svg>
          </div>
        </div>
        {(label || children) && (
          <span className={styles.label}>{children || label}</span>
        )}
      </label>
    );
  },
);

Radio.displayName = 'Radio';
